var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _path, _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKadminWordmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 280 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    rx: 10,
    x: 4,
    y: 4,
    fill: "#111"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 9,
    width: 6,
    height: 6,
    rx: 0.8,
    transform: "rotate(45 32 12)",
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 19,
    width: 6,
    height: 6,
    rx: 0.8,
    transform: "rotate(45 22 22)",
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 39,
    y: 19,
    width: 6,
    height: 6,
    rx: 0.8,
    transform: "rotate(45 42 22)",
    fill: "white"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 29,
    width: 6,
    height: 6,
    rx: 0.8,
    transform: "rotate(45 12 32)",
    fill: "white"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 29,
    width: 6,
    height: 6,
    rx: 0.8,
    transform: "rotate(45 52 32)",
    fill: "white"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 39,
    width: 6,
    height: 6,
    rx: 0.8,
    transform: "rotate(45 22 42)",
    fill: "white"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 39,
    y: 39,
    width: 6,
    height: 6,
    rx: 0.8,
    transform: "rotate(45 42 42)",
    fill: "white"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 49,
    width: 6,
    height: 6,
    rx: 0.8,
    transform: "rotate(45 32 52)",
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 26.9 26 L 29.9 26 L 29.9 29.6 L 33.8 26 L 36.8 26 L 32.3 31.4 L 37.1 38 L 34.1 38 L 30.2 33.5 L 29.9 33.8 L 29.9 38 L 26.9 38 Z",
    fill: "white"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 76,
    y: 44,
    fontFamily: "Inter, -apple-system, BlinkMacSystemFont, sans-serif",
    fontSize: 34,
    fontWeight: 700,
    fill: "currentColor",
    letterSpacing: -0.5
  }, "kadmin")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKadminWordmark);
export default __webpack_public_path__ + "static/media/kadmin-wordmark.68990d325dbf660dbe2edd98ea0eac0b.svg";
export { ForwardRef as ReactComponent };